import React from 'react';
import { PullQuote } from './ui/PullQuote';
import { TestimonialBlock } from './ui/TestimonialBlock';
import { CTASection } from './CTASection';
export function ContentSection() {
  return <article className="prose prose-lg prose-headings:font-bold prose-headings:text-gray-900 prose-p:text-gray-700 prose-p:leading-relaxed prose-a:text-[#2563EB] max-w-none" data-id="element-8">
      {/* Opening Story */}
      <p data-id="element-9">
        Lisa staat in de keuken. Haar hond Max ligt bij de deur. Lisa loopt naar
        hem toe om hem een aai te geven.
      </p>
      <p data-id="element-10">Max kijkt even weg. Likt zijn lippen. Gaapt.</p>
      <p data-id="element-11">Lisa denkt: "Hij is moe."</p>
      <p data-id="element-12">
        Maar Max zegt eigenlijk iets heel anders: "Ik voel me ongemakkelijk. Kun
        je wat afstand nemen?"
      </p>
      <p className="font-bold text-gray-900" data-id="element-13">Ze mist het. Weer.</p>

      {/* Section 1 */}
      <h2 className="mt-12 mb-6 text-3xl" data-id="element-14">De onzichtbare gesprekken</h2>
      <p data-id="element-15">
        Wat Lisa niet weet: Max "praat" de hele dag tegen haar. Niet met
        woorden, maar met tientallen kleine signalen. Een blik die wegdraait.
        Oren die naar achteren gaan. Een poot die even optilt.
      </p>
      <p data-id="element-16">
        Het zijn geen willekeurige bewegingen. Het is een complete taal — met
        een eigen grammatica en woordenschat.
      </p>
      <p data-id="element-17">
        Maar wij mensen? Wij zijn verbale dieren. We luisteren naar woorden.
        Niet naar lichaamstaal.
      </p>
      <p data-id="element-18">
        En dus missen we wat onze hond ons probeert te vertellen. Dag in, dag
        uit.
      </p>

      <TestimonialBlock quote="Voordat ik dit begreep, was het lastig om de lichaamstaal van onze hond te begrijpen. Nu zijn we bewuster geworden. Er is veel meer rust in zijn gedrag." author="Bianca S." data-id="element-19" />

      {/* Section 2 */}
      <h2 className="mt-12 mb-6 text-3xl" data-id="element-20">
        Waarom miscommunicatie zo vaak voorkomt
      </h2>
      <p data-id="element-21">
        Hondengedragsdeskundige Amee de Bruijn legt uit waarom dit probleem zo
        wijdverbreid is:
      </p>
      <p data-id="element-22">
        "Mensen en honden communiceren van nature op een compleet andere manier.
        Wij praten, gebaren met onze handen, maken oogcontact. Maar in
        hondentaal kan dat juist bedreigend overkomen."
      </p>

      <PullQuote data-id="element-23">
        Zelfs iets simpels als rechtop naar je hond toe lopen en hem van bovenaf
        aaien — voor ons een liefdevol gebaar — kan voor een hond voelen als
        "indringend en onbeleefd."
      </PullQuote>

      <p data-id="element-24">
        Geen wonder dat zoveel hondeneigenaren vastlopen. Ze doen hun best, maar
        spreken onbewust de verkeerde taal.
      </p>

      {/* Section 3 */}
      <h2 className="mt-12 mb-6 text-3xl" data-id="element-25">Wat je hond wél verstaat</h2>
      <p data-id="element-26">Het goede nieuws? Die hondentaal is te leren.</p>
      <p data-id="element-27">
        Wanneer je begrijpt wat je hond communiceert — en hoe je op zijn manier
        kunt "terugpraten" — verandert alles.
      </p>
      <p data-id="element-28">
        Plotseling snap je waarom hij in bepaalde situaties gespannen reageert.
        Je herkent de signalen vóórdat er een probleem ontstaat. En je hond? Die
        voelt zich eindelijk begrepen.
      </p>

      <TestimonialBlock quote="Ik kijk nu ook echt anders naar mijn hond. Waar ik dacht vooral een angstige hond te hebben, blijkt zij gewoon heel beleefd te zijn. Mijn hele benadering is veranderd." author="Irma V." data-id="element-29" />

      {/* Section 4 */}
      <h2 className="mt-12 mb-6 text-3xl" data-id="element-30">Van frustratie naar begrip</h2>
      <p data-id="element-31">
        Dit is precies waarom meer dan 100.000 Nederlandse hondeneigenaren het
        gratis online webinar "Communiceren met je Hond" van Amee Buijs,
        gedragsdeskundige en oprichter van Stressless Dogs, hebben gevolgd.
      </p>

      <CTASection data-id="element-32" />

      <TestimonialBlock quote="Toen ik toepaste wat de cursus me leerde, zag ik meteen dat mijn hond totaal anders reageerde. Zijn hele houding naar mij toe is veranderd vanaf stap 1." author="Johan S." data-id="element-33" />

      {/* Final Section */}
      <h2 className="mt-12 mb-6 text-3xl" data-id="element-34">Jouw hond praat al tegen je</h2>
      <p data-id="element-35">De vraag is niet óf je hond communiceert.</p>
      <p className="text-xl font-medium italic text-gray-900" data-id="element-36">
        De vraag is: versta je hem?
      </p>
    </article>;
}